// @copyright  2006 - 2023 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'project-checklist-task.page.title': 'Tasks',
    'project-checklist-task.page.archive.title': 'Archived Tasks',
    'project-checklist-task.page.bin.title': 'Binned Tasks',
    'project-checklist-task.page.assignees': 'Assignees',
    'project-checklist-task.page.search_results': 'Search Results',
    'project-checklist-task.page.create.title': 'Create New Task',
    'project-checklist-task.page.search.title': 'Find Tasks',
    'project-checklist-task.page.edit.title': 'Edit Task',
    'project-checklist-task.page.view.title': 'View Task',
    'project-checklist-task.page.all': 'All',

    'project-checklist-task.button.cancel': 'Cancel',
    'project-checklist-task.button.select': 'Select',
    'project-checklist-task.button.find': 'Find Tasks',
    'project-checklist-task.button.search': 'Apply',
    'project-checklist-task.button.create': 'Create Task',
    'project-checklist-task.button.new': 'New Task',
    'project-checklist-task.button.save': 'Save Changes',
    'project-checklist-task.button.archive': 'Archive',
    'project-checklist-task.button.bin': 'Bin',
    'project-checklist-task.button.bin-comment': 'Bin',
    'project-checklist-task.button.empty': 'Empty Bin',
    'project-checklist-task.button.delete': 'Delete',
    'project-checklist-task.button.edit': 'Edit',
    'project-checklist-task.button.restore': 'Restore',
    'project-checklist-task.button.reset': 'Reset',
    'project-checklist-task.button.comment': 'Comment',
    'project-checklist-task.button.assignees': 'Assignees',
    'project-checklist-task.button.binned_comments': 'Binned Comments',
    'project-checklist-task.button.active_comments': 'Active Comments',

    'project-checklist-task.placeholder.search': 'Search tasks',

    'project-checklist-task.link.create_first_project_checklist_task': 'Click here to create your first task',
    'project-checklist-task.link.project_checklist_tasks': ' Return to Tasks',
    'project-checklist-task.link.active': 'Active Tasks',
    'project-checklist-task.link.archive': 'Archived Tasks',
    'project-checklist-task.link.bin': 'Binned Tasks',
    'project-checklist-task.link.retry': 'Click here to retry',

    'project-checklist-task.checkbox.all': 'Check All',
    'project-checklist-task.checkbox.actions_label': 'with selected',

    'project-checklist-task.label.project_checklist_name': 'Project Checklist',
    'project-checklist-task.label.description': 'Description',

    'project-checklist-task.label.priority.low': 'LOW',
    'project-checklist-task.label.priority.medium': 'MEDIUM',
    'project-checklist-task.label.priority.high': 'HIGH',

    'project-checklist-task.label.from__due_date': 'From due date',
    'project-checklist-task.label.to__due_date': 'To due date',
    'project-checklist-task.label.due_date': 'Due Date',

    'project-checklist-task.label.progress': 'Progress',

    'project-checklist-task.label.priority': 'Priority',

    'project-checklist-task.label.status': 'Status',

    'project-checklist-task.sort.field_label': 'Field',
    'project-checklist-task.sort.direction_label': 'Direction',
    'project-checklist-task.sort.direction_ascending': 'Ascending',
    'project-checklist-task.sort.direction_descending': 'Descending',

    'project-checklist-task.modal.title.project_checklist_task_archive': 'Archive Task',
    'project-checklist-task.modal.title.project_checklist_task_bin': 'Bin Task',
    'project-checklist-task.modal.title.project_checklist_task_bin_comment': 'Bin Comment',
    'project-checklist-task.modal.title.project_checklist_task_delete_comment': 'Delete Comment',
    'project-checklist-task.modal.title.project_checklist_task_restore_comment': 'Restore Comment',
    'project-checklist-task.modal.title.project_checklist_task_bin_user': 'Unassign Member',
    'project-checklist-task.modal.title.project_checklist_task_bin_empty': 'Delete All Binned Tasks',
    'project-checklist-task.modal.title.project_checklist_task_delete_permanently': 'Delete Task',
    'project-checklist-task.modal.title.project_checklist_task_restore': 'Restore Task',

    'project-checklist-task.modal.message.project_checklist_task_archive': 'Are you sure that you want to move this task to the archive ? | Are you sure that you want to move these tasks to the archive ?',
    'project-checklist-task.modal.message.project_checklist_task_bin': 'Are you sure that you want to move this task to the bin ? | Are you sure that you want to move these tasks to the bin ?',
    'project-checklist-task.modal.message.project_checklist_task_bin_comment': 'Are you sure that you want to move this comment to the bin ? | Are you sure that you want to move these comments to the bin ?',
    'project-checklist-task.modal.message.project_checklist_task_delete_comment': 'Are you sure that you want to permanently delete this comment ? | Are you sure that you want to permanently delete these comments ?',
    'project-checklist-task.modal.message.project_checklist_task_restore_comment': 'Are you sure that you want to restore this comment ? | Are you sure that you want to restore these comments ?',
    'project-checklist-task.modal.message.project_checklist_task_bin_user': 'Are you sure that you want to unassign this member ? | Are you sure that you want to unassign these members ?',
    'project-checklist-task.modal.message.project_checklist_task_bin_empty': 'Are you sure that you want to permanently delete all binned tasks? This action cannot be undone!',
    'project-checklist-task.modal.message.project_checklist_task_delete_permanently':
        'Are you sure that you want to permanently delete this task? This action cannot be undone. | Are you sure that you want to permanently delete these tasks? This action cannot be undone.',
    'project-checklist-task.modal.message.project_checklist_task_restore': 'Are you sure that you want to restore this task? | Are you sure that you want to restore these tasks?',

    'project-checklist-task.success.message.project_checklist_task_created': 'Your task has been created',
    'project-checklist-task.success.message.project_checklist_task_updated': 'Your task has been updated',
    'project-checklist-task.success.message.project_checklist_task_restored': 'Your task has been restored | All selected tasks were restored',
    'project-checklist-task.success.message.project_checklist_task_deleted': 'Your task has been permanently deleted | All selected tasks were permanently deleted',
    'project-checklist-task.success.message.archived_project_checklist_tasks': 'Your task was moved to the archive | All selected tasks were moved to the archive',
    'project-checklist-task.success.message.binned_project_checklist_tasks': 'Your task was moved to the bin | All selected tasks were moved to the bin',
    'project-checklist-task.success.message.binned_project_checklist_comments': 'Your comment was moved to the bin | All selected comments were moved to the bin',
    'project-checklist-task.success.message.deleted_project_checklist_comments': 'Your comment has been permanently deleted | All selected comments were permanently deleted',
    'project-checklist-task.success.message.restored_project_checklist_comments': 'Your comment has been restored | All selected comments were restored',
    'project-checklist-task.success.message.binned_project_checklist_user': 'Member has been unassigned | All members have been unassigned',
    'project-checklist-task.success.message.project_checklist_task_bin_emptied': 'All binned tasks were permanently deleted!',

    'project-checklist-task.error.message.archived_project_checklist_tasks': 'This task was already moved to the archive | These tasks were already moved to the archive',
    'project-checklist-task.error.message.binned_project_checklist_tasks': 'This task was already moved to the bin | These tasks were already moved to the bin',
    'project-checklist-task.error.message.binned_project_checklist_comments': 'This comment was already moved to the bin | These comments were already moved to the bin',
    'project-checklist-task.error.message.deleted_project_checklist_comments': 'This comment was already deleted | These comments were already deleted',
    'project-checklist-task.error.message.restored_project_checklist_comments': 'This comment was already restored | These comments were already restored',
    'project-checklist-task.error.message.binned_project_checklist_user': 'This member was already unassigned | These members were already unassigned',
    'project-checklist-task.error.message.project_checklist_task_bin_emptied': 'All binned tasks were already deleted',
    'project-checklist-task.error.message.project_checklist_task_deleted': 'This task was already permanently deleted | These tasks were already permanently deleted',
    'project-checklist-task.error.message.project_checklist_task_restored': 'This task was already restored | These tasks were already restored',
    'project-checklist-task.error.message.error_loading_page': 'Sorry, there was an error loading task.| Sorry, there was an error loading tasks.',

    'project-checklist-task.message.search.no_archived_project_checklist_tasks': "You don't have any archived tasks.",
    'project-checklist-task.message.search.no_binned_project_checklist_tasks': "You don't have any binned tasks.",
};
